import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { Sidebar } from '@destination/components';

export interface INavigationItem {
  icon: React.ReactNode;
  label: string;
  url: string;
  newTab?: boolean;
}

export interface INavigation {
  items: INavigationItem[];
}

export default function Navigation({ items }: INavigation) {
  const { t } = useTranslation(undefined, { keyPrefix: 'navigation' });

  return (
    <nav className="flex h-full flex-col justify-between">
      {items.map(({ icon, label, url, newTab }) => (
        <NavLink key={url} to={url} target={newTab ? '_blank' : '_self'}>
          {({ isActive }) => (
            <Sidebar.MenuItem
              icon={icon}
              label={t(label)}
              isActive={isActive}
            />
          )}
        </NavLink>
      ))}
    </nav>
  );
}
